import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { headerColumns3, translations } from './../../../../core/models/call-offer';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { serverError } from './../../../../core/models/messages';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, ICountry, State } from 'country-state-city';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Subject, takeUntil } from 'rxjs';
import { PaysserviceService } from '@core/services/pays/paysservice.service';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { SubscriptionService } from '@core/services/subscription.service';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';

const DOMPurify = require('dompurify')

@Component({
  selector: 'app-list-job-offer',
  templateUrl: './list-job-offer.component.html',
  styleUrls: ['./list-job-offer.component.css'],
})

export class ListJobOfferComponent {
  
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  @ViewChild('editor') editor: any; // ViewChild reference to the Quill editor
  freeSearchActive :boolean = false;
  freeSearch: boolean = false;
  loadSpinner: boolean = false;
  idclientConnected: any;
  mobilities: any[] = [];
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  skills: any = [];
  name: any = [];
  isLoadSpinner: boolean = true;
  btnSearchactive : boolean = false;
  paysList: ICountry[] = [];
  countries: any[] = [];
  countriesMobilite: any[] = [];
  stateList: any = [];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  listjoboffers: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  updateform!: FormGroup;
  skillsList: { name_FR: string }[] = [];
  dataHeader: any = [];
  listNames: string[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  private unsubscribeAll: Subject<void> = new Subject();
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns3;
  seeMore: boolean = false;
  pagination : boolean =false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  types: any = [];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  statee = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  isCollapsed = true;
  activeSubscription: any;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '1 mois' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },

  ];
  disponibilite = [
     { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  postType = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },

  ];

  poste = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'],
  ];
  editorContent: string = '<p>Hello World!</p>';
  typeintervenant: any;

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private appeloffreservice: EsnAppeloffreService,
    private localStorageService: LocalStorageService,
    private paysServices:PaysserviceService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private subscriptionService: SubscriptionService,
    private router : Router
  ) {}

  ngOnInit() {
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')    
    this.idclientConnected = connectedUser?.company?.uuid
    
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.paysList=this.paysServices.getAllCountries();
    this.getListSkills();
    this.getListjoboffer();
    this.getListElementHeader();
    this.countries = Country.getAllCountries();
    if (!this.stateList.length) {
      this.searchForm.get('city')?.disable(); // Désactiver
    } else {
      this.searchForm.get('city')?.enable();  // Activer
    }
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    this.updateform = this.formBuilder.group({
      id: [''],
      name: ['', Validators.required],
      city: [[]],
      country: [[], Validators.required],
      post_type: [''],
      contract_type: [''],
      availability: [''],
      skills: [''],
      years_of_experience: ['', Validators.required],
      tjm: [''],
      salary: [''],
      description: ['', Validators.required],
      passeport_talent: [''],
      profile_abroad: [''],
      otherSkills: [[]],
    });
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
    console.log('this.updateform',this.updateform.value)
  }
  getRemainingPays(pay: any): string {
    if (!Array.isArray(pay) || pay.length <= 3) {
      return ''; 
    }
    return pay.map(m => String(m)).join(', '); 
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    if(Array.isArray(contractTypes)) return contractTypes?.map(type => contractMap[type.toString()] || '').join(', ');
    else return ''
  }
  ngAfterViewInit() {}
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  sortData(item: string) {
    for (const iterator of headerColumns3) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 0;
    this.endIndex = 5;

    if (this.searchForm.dirty)
      this.listjoboffers = this.sortDataService.sortArray(
        this.listjoboffers,
        item,
        this.currentSortDirection
      );
    else this.getListjoboffer();
  }

  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appeloffreservice
        .getHeaderElements(16)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.jobofferservice
        .listPagejobofferActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }
  getSkillsArray(offre: any): string[] {
    if (offre && offre.skills) {
      return offre.skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(skills: string): string {
    if (!skills) {
      return '';
    }
    return skills.split(',').map(s => s.trim()).join(', ');
  }
  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.appeloffreservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.jobofferservice
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }
  getClass(item: string): string {
    if (item === 'Nom entreprise') {
      return 'th-fixed';
    } else if (item === 'Poste') {
      return 'th-fixed2';
    }
    return '';
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchjoboffer();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListjoboffer();
      }
    }
  }
  onSubmit() {
    if(!this.freeSearchActive) {
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.searchjoboffer(1);
    } else{
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.freeSearchjoboffer(1);
      
    }
  }
  showPasseportTalent: boolean = false;
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.countriesMobilite=this.updateform.get('country')?.value;
    this.countriesMobilite=this.countriesMobilite.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );
    
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });

    this.countriesMobilite.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);

        });
      }*/
    }
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  getListjoboffer() {
    const params = {
      esn_id: this.idclientConnected,
      per_page: this.pageSize,
      page: this.currentPage} 
    this.spinner.show();
    this.jobofferservice.getListjoboffer(params).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listjoboffers = response.data.data;
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  // convertKToNumber(value: any) {
  //   if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
  //     return parseFloat(value.slice(0, -1)) * 1000;
  //   } else if (!isNaN(value)) {
  //     return parseFloat(value) * 1000;
  //   }
  //   return parseFloat(value);
  // }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobOffer: ['', data?.ID_jobOffer],
      esn_id: ['', data?.esn_id],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      contract_type: [[], data?.contract_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      post_type: [[], data?.post_type],
      city: [[], data?.city],
      country: [[], data?.country],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
      state: [null, data?.state],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  createFreeSearchForm(data?: any) {
    return this.formBuilder.group({

      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}



  /* search */
  searchjoboffer(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(valueForm.desired_salary_range?.toString());
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      esn_id: this.idclientConnected,
      ID_jobOffer: valueForm.ID_jobOffer,
      name: valueForm.name,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      state: valueForm.state,

      city: valueForm.city,
      country: valueForm.country,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      search: this.transformSearch(valueForm?.search),
      per_page: this.pageSize,
      page: this.currentPage
    };
    this.spinner.show();
    this.jobofferservice.searchjoboffer(data).subscribe({
      next: (resSearch) => {
        this.listjoboffers = resSearch.data.data.slice(0, this.endIndex);
        this.totalItems = resSearch.data.total;
        this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  freeSearchjoboffer(pageNumber: number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;

    let data = {
      page: this.currentPage,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.jobofferservice.freeSearchjoboffer(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.startSearching = false;
              this.listjoboffers = resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  activerjoboffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment activer cette offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, activé !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobofferservice.activerjoboffer(id).subscribe({
          next: (response: any) => {
            this.toastrService.success(
              'L’offre d’emploi a été activé avec succès .'
            );
            this.searchjoboffer();
          },
          error: (error: any) => {
          },
        });
      }
    });
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    this.searchForm = this.createSearchForm();
    this.searchForm.reset();
    this.getListjoboffer();
  }
  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    this.activeForm = form;
    if (form === 'freeSearch') {
      this.freeSearchActive = true;
      this.freeSearchForm.enable(); 
    } else if (form === 'guidedSearch') {
      this.freeSearchActive = false;
      this.searchForm.enable();
    }
}
  desactiverjoboffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment désactiver cette offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, désactivé !',
      cancelButtonText: 'Annuler ',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobofferservice.activerjoboffer(id).subscribe({
          next: (response: any) => {
            this.toastrService.success(
              'L’offre d’emploi a été désactivé avec succès.'
            );
            this.searchjoboffer();
          },
          error: (error: any) => {
          },
        });
      }
    });
  }
  // Ajoutez cette méthode pour obtenir les informations sur le contrat par ID
  // contratInfoById(id: number): any {
  //   return this.contrat.find((c) => c.id === id);
  // }
  openModal(offre: any) {
    // this.skills = [];
    // const skillsArray = offre.skills_job;
    // if (skillsArray?.length !== 0) {
    //   this.skills = skillsArray.map((skill: any) => skill.subCateg_id);
    // }
    this.updateform.patchValue({
      id: offre.uuid,
      name: offre.name,
      city: offre.city,
      country: offre.country,
      skills: this.skills,
      post_type: offre.post_type,
      availability: offre.availability,
      // contract_type: this.getContractType(offre.contract_type),
      description: offre.description,
      salary: offre.salary,
      tjm: offre.tjm,
      years_of_experience: offre.years_of_experience,
      passeport_talent: offre.passeport_talent,
      profile_abroad: offre.profile_abroad,
      otherSkills: offre.otherSkills,
    });
    this.updateform.get('contract_type')?.setValue(offre.contract_type);
    this.updateform.get('contract_type')?.updateValueAndValidity();
    this.onCountryChange('add');
  }

  getContractType(contractIds: string[]): any[] {
    return this.contrat.filter(c => contractIds.includes(c.id));
  }

 updatejoboffer() {
  this.updateform.markAllAsTouched();
  this.updateform.markAsDirty();
    const skills = this.updateform.get('skills')?.value || [];
    this.skills = skills.map((skill: any) => skill);

    let otherSkills = this.updateform.get('otherSkills')?.value;
    if (typeof otherSkills === 'string' && otherSkills) {
      otherSkills = otherSkills.split(',').map(skill => skill.trim());
    }

    if (this.updateform.value.availability === null) {
      this.updateform.patchValue({ availability: '' });
    }

    if (this.updateform.value.post_type === null) {
      delete this.updateform.value.post_type;
    }

    this.updateform.patchValue({
      years_of_experience: this.updateform.value?.years_of_experience? String(this.updateform.value?.years_of_experience) : null,
      salary: this.updateform.value?.salary? String(this.updateform.value?.salary) : null,
      tjm: this.updateform.value?.tjm? String(this.updateform.value.tjm) : null,
      skills: this.skills,
      otherSkills: otherSkills || [],
    });

    this.jobofferservice.updateJobOffer(this.updateform.value.id, this.updateform.value)
      .subscribe({
        next: (res: any) => {
          this.close_modal_add();
          this.getListjoboffer();
          this.toastrService.success('Offre d\'emploi modifiée avec succès');
        },
        error: (error) => {
        },
      });
  }


  close_modal_add() {
    let btnClose = document.getElementById('ModalClose_update_offre');
    this.updateform.reset();
    if (btnClose) {
      btnClose.click();
    }
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.currentPage = 0
    this.getListjoboffer();
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  subscriptionCanAccess(featureName: string): boolean {
    return this.subscriptionService.subscriptionCanAccess(featureName);
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
     if (this.searchForm.dirty && this.btnSearchactive) {
      this.searchjoboffer(this.currentPage);
    } 
    else if (this.freeSearchForm.dirty && this.btnSearchactive){
      this.freeSearchjoboffer(this.currentPage);
    }
    else {
      this.getListjoboffer();
    }
  }
 /**
 * Redirects to a specific route based on the conditions of the provided job offer.
 *
 * @param offer - The job offer object containing the properties:
 *  - `has_test_esn` (boolean): Indicates if the ESN test is enabled.
 *  - `has_test_wegestu` (boolean): Indicates if the WGU test is enabled.
 *
 * @remarks
 * The function evaluates the `offer` object based on the following conditions:
 * 1. If `has_test_esn` is false and `has_test_wegestu` is false:
 *    - Redirects to `/offres-emploi/add-test-wegestu` with a query parameter `test=null`.
 * 2. If `has_test_esn` is true and `has_test_wegestu` is false:
 *    - Redirects to `/offres-emploi/add-test` with a query parameter `test=ESN`.
 * 3. If `has_test_esn` is false and `has_test_wegestu` is true:
 *    - Redirects to `/offres-emploi/add-test-wegestu` with a query parameter `test=WGU`.
 *
 */
  redirectTest(offer: any) {
    if (!offer.has_test_esn && !offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'], {
        queryParams: { jobId: offer.uuid },
        state: { testType: 'NO_TEST' },
      });
    } else if (offer.has_test_esn && !offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test'], {
        queryParams: { jobId: offer.uuid, action: 'update' },
        state: {  testType: 'ESN' },
      });
    } else if (!offer.has_test_esn && offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'], {
        queryParams: { jobId: offer.uuid, action: 'update' },
        state: {  testType: 'WGU' },
      });
    }
  }
  redirectEdit(offer: any) {
    
    this.router.navigate(['/offres-emploi/edit-offre-emploi'])
    }

  onContentChange(event: any): void {
    if (event.html) {
      const sanitizedContent = DOMPurify.sanitize(event.html);
      if (sanitizedContent !== this.updateform.get('description')?.value) {
        this.updateform.patchValue(
          { description: sanitizedContent },
          { emitEvent: false } 
        );
      }
    }

  }
}

